/**
 * Componente para mostrar el estado del ticket con color y label apropiado
 * 
 * Referencia: sistema-tickets-frontend-COMPLETO.md Sección 2.1
 * 
 * Ahora usa el mapeo de estados visibles:
 * - Abierto (abierto, nuevo, esperando_cliente, en_espera)
 * - En Progreso (en_progreso)
 * - Completado (pendiente_validacion)
 * - Prueba (pendiente_validacion_nube)
 * - Cerrado (resuelto, cerrado)
 */

import React from 'react';
import { Chip } from '@mui/material';
import { getEstadoVisible, COLORES_ESTADOS_VISIBLES } from '../../../utils/soporte/estadosMapping';

/**
 * Componente EstadoBadge
 * 
 * @param {Object} props
 * @param {string} props.status - Estado interno del ticket (nuevo, en_progreso, etc.)
 * @param {string} props.fontSize - Tamaño de fuente opcional (ej: '1.0806rem')
 * @returns {JSX.Element}
 */
const EstadoBadge = ({ status, fontSize }) => {
  // Obtener el estado visible desde el estado interno
  const estadoVisible = getEstadoVisible(status);
  const config = COLORES_ESTADOS_VISIBLES[estadoVisible] || COLORES_ESTADOS_VISIBLES.abierto;
  
  return (
    <Chip
      label={config.label}
      size="small"
      sx={{
        bgcolor: config.bgcolor,
        color: config.color,
        fontWeight: 'bold',
        border: `1px solid ${config.color}`,
        ...(fontSize && { fontSize }) // ✅ Aplicar fontSize si se proporciona
      }}
    />
  );
};

export default EstadoBadge;
